import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

import { Observable, of } from 'rxjs';

import { MtnaLogger } from '@mtna/lib-ui';
import { Catalog } from '@mtna/pojo-consumer-ui';

import { RdsDataProductDialogService } from '../../data-product-selection-dialog/data-product-dialog.service';
import { RDS_ROOT_CATALOG, RdsDataProductGuard } from './data-product-guard.service';
import { RdsApiService } from './rds-api.service';

/**
 * If a route is navigated to without a catalog and data product in the URL,
 * use the default if they are set, otherwise open the data product selection dialog
 *
 * @author Will Davis <will.davis@mtna.us>
 */
@Injectable({ providedIn: 'root' })
export class RdsEmptyDataProductGuardService extends RdsDataProductGuard implements CanActivate {
  constructor(
    dataProductDialog: RdsDataProductDialogService,
    rdsApiService: RdsApiService,
    @Inject(RDS_ROOT_CATALOG) getRootCatalog: Observable<Catalog>,
    logger: MtnaLogger,
    private router: Router
  ) {
    super(dataProductDialog, rdsApiService, getRootCatalog, logger);
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    // Once a catalog and data product are set, naviate using them as parameters
    super.canActivate(next, state).subscribe(_ => {
      this.router.navigate([`${state.url}/${this.rdsApiService.catalogId}/${this.rdsApiService.dataProductId}`]);
    });
    return of(false);
  }
}
